export default "__VITE_ASSET__DCdckg$m__"